var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1269 -193)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#758091",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1269 193)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#758091",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1269 204)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#758091",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1280 193)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#758091",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1280 204)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.7077f786229db18cbd2d90d31acf3ca0.svg";
export { ForwardRef as ReactComponent };